import React from "react";
import { Link } from "react-router-dom";
import { formatISTDate } from "../../utils/dateTime";

const BlogCard = ({ blog }) => (
  <article className="group border border-white/10 bg-cynos-card hover:border-white transition-colors" data-testid={`blog-card-${blog.slug}`}>
    <Link to={`/blog/${blog.slug}`} className="block">
      <div className="aspect-[16/10] overflow-hidden bg-cynos-surface">
        {blog.image && <img src={blog.image} alt={blog.title} className="h-full w-full object-cover zoom-on-hover" loading="lazy" />}
      </div>
      <div className="p-5">
        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-cynos-red">
          {blog.category || "CYNOS"} - {formatISTDate(blog.created_at)}
        </div>
        <h2 className="mt-3 font-anton text-3xl uppercase leading-none group-hover:text-cynos-red transition-colors">{blog.title}</h2>
        <p className="mt-4 text-sm leading-6 text-zinc-400">{blog.excerpt}</p>
        <div className="mt-5 flex items-center justify-between gap-4">
          <span className="text-xs uppercase tracking-[0.2em] text-zinc-500">By {blog.author || "CYNOS"}</span>
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-white">Read More</span>
        </div>
      </div>
    </Link>
  </article>
);

export default BlogCard;
